import React, { useState } from 'react';
// material
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Hidden, Grid } from '@material-ui/core';
// entities
import { CampaignContact } from '../../../entities/site';

interface CampaignContactNavigateProps {
  previous: CampaignContact;
  next: CampaignContact;
  onClick(contact: CampaignContact): void;
}

const CampaignContactNavigate: React.FC<CampaignContactNavigateProps> = (props) => {
  const classes = useStyles();

  console.log('props.previous', props.previous);
  console.log('props.next', props.next);

  return (
    <div className={((props.previous && props.previous.id) || (props.next && props.next.id) ? classes.container : classes.containerEmpty)}>
        {(props.previous && props.previous.id) &&
          <div className={classes.button} onClick={() => props.onClick(props.previous)}>
            <ArrowBackIcon className={classes.buttonIcon} />
            <div className={classes.buttonTextLeft}>{props.previous.firstName} {props.previous.lastName}</div>
          </div>
        }
        {(!props.previous || !props.previous.id) &&
          <div className={classes.buttonEmpty} />
        }
        {(props.next && props.next.id) &&
          <div className={classes.button} onClick={() => props.onClick(props.next)}>
            <div className={classes.buttonTextRight}>{props.next.firstName} {props.next.lastName}</div>
            <ArrowForwardIcon className={classes.buttonIcon} />
          </div>
        }
        {(!props.next || !props.next.id) &&
          <div className={classes.buttonEmpty} />
        }
    </div>
  );

}

export default CampaignContactNavigate;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 20,
      marginBottom: 10
    },
    containerEmpty: {
      marginTop: 0,
      marginBottom: 0,
    },
    button: {
      padding: 10,
      backgroundColor: '#def9ff',
      display: 'flex',
      borderRadius: 4,
      cursor: 'pointer'
    },
    buttonEmpty: {
      padding: 10,
      display: 'flex'
    },
    buttonIcon: {
      fontSize: 18,
      color: '#1babc8'
    },
    buttonTextLeft: {
      fontSize: 12,
      color: '#1babc8',
      paddingTop: 2,
      paddingLeft: 2
    },
    buttonTextRight: {
      fontSize: 12,
      color: '#1babc8',
      paddingTop: 2,
      paddingRight: 2
      
    }
  })
);


// WEBPACK FOOTER //
// ./src/pages/campaign/components/CampaignContactNavigate.tsx